const React = require('react');
const delay = require('mn-utils/delay');
const param = require('mn-utils/param');
const formatTime = require('mn-utils/formatTime');
const withState = require('../../../utils/withState');
const WrapperWithLoading = require('../WrapperWithLoading/B');
const ButtonDownload = require('../Button/DownloadA');
const ButtonPrint = require('../Button/PrintA');


module.exports = withState((setState) => {
  return (state, props) => {
    const {
      urlPrefix,
    } = props;
    const prefix = props.prefix || 'transactions';
    const filter = props.filter || {};
    const {
      from: dateFrom,
      to: dateTo,
    } = filter;

    function getLink(key) {
      const dateMask = '{yyyy}-{mm}-{dd}';

      const queryString = param({
        search: filter.search || null,
        from: dateFrom && formatTime(dateFrom, dateMask),
        to: dateTo && formatTime(dateTo, dateMask),
        state: filter.state,
      });

      return urlPrefix + key + (queryString ? ('?' + queryString) : '');
    }
    function getName(key) {
      return prefix
        + (filter.state ? '_' + filter.state : '')
        + (dateFrom ? '_' + formatTime(dateFrom, '{yyyy}-{mm}-{dd}') : '')
        + (dateTo ? '_' + formatTime(dateTo, '{yyyy}-{mm}-{dd}') : '')
        + '.' + key;
    }
    function handleLoading() {
      setState({
        loading: true,
      });
      delay(setState, 2000, [{loading: false}]);
    }

    /*
    console.log(
        formatTime(dateFrom, '{yyyy}-{mm}-{dd}'),
        formatTime(dateTo, '{yyyy}-{mm}-{dd}'),
    );
    */

    return (
      <WrapperWithLoading
        loading={state.loading}
        inner={{
          className: 'layoutRow fvaC fhaS hmin34*2 ' + (props.className || ''),
        }}
      >
        {/*<ButtonPrint*/}
        {/*  onClick={handleLoading}*/}
        {/*  target="_blank"*/}
        {/*  href={getLink('pdf')}*/}
        {/*  download={getName('pdf')}*/}
        {/*/>*/}
        <ButtonDownload
          className="ml36"
          onClick={handleLoading}
          target="_blank"
          href={getLink('csv')}
          download={getName('csv')}
          name="Download CSV"
          disabled={props.disabled}
        />
      </WrapperWithLoading>
    );
  };
});
